export interface BenefitCtaConfig {
  path?: string
  /**
   * DOM element ID to scroll to when the benefit tile is clicked.
   * Must match the `id` attribute on the target carousel/section.
   */
  scrollTarget?: string
  /**
   * Filter category to auto-select on the target carousel after scrolling.
   * Dispatches a 'luxplus-filter-select' custom event on the scroll target element.
   */
  filterCategory?: string
}

export const SUPPORTED_BENEFIT_TYPES: Array<App.LuxPlusBenefitType> = [
  'discounted_flash',
  'discounted_insurance',
  'discounted_tours',
  'early_access',
  'exclusive_offers',
  'hotel_inclusions',
  'priority_support',
  'cruise_inclusions',
  'discounted_experiences',
  'partner_promo_code',
]

export const BENEFITS_CTA_CONFIG: Record<App.LuxPlusBenefitType, BenefitCtaConfig> = {
  discounted_flash: {
    scrollTarget: 'discounted_flash',
    filterCategory: 'member-discounts',
  },
  hotel_inclusions: {
    scrollTarget: 'discounted_flash',
    filterCategory: 'bonus-inclusions',
  },
  exclusive_offers: {
    scrollTarget: 'discounted_flash',
    filterCategory: 'hidden-offers',
  },
  early_access: {
    scrollTarget: 'discounted_flash',
    filterCategory: 'early-access',
  },
  discounted_tours: {
    scrollTarget: 'discounted_tours',
  },
  cruise_inclusions: {
    scrollTarget: 'cruise_inclusions',
  },
  discounted_experiences: {
    scrollTarget: 'discounted_experiences',
  },
  discounted_insurance: {
    path: '/travel-protection',
  },
  priority_support: {},
  partner_promo_code: {},
  promo: {},
  voucher: {},
}

export const SAVE_THOUSANDS_REGIONS = ['ZA', 'TH', 'KR', 'ID', 'JP', 'TW', 'PH', 'VN']

export const LANDING_BENEFIT_MESSAGES = {
  discountedFlashTitle: { id: 'Af2AAn6bKmLcmn7cFbNJ', defaultMessage: 'Discounted pricing on hotels', description: 'Landing page benefit title for discounted flash sales' },
  discountedFlashDescription: { id: 'TJqMLB_DhUTyKR1IgplB', defaultMessage: 'Save even more on our Limited Time LUX Exclusive offers', description: 'Landing page benefit description for discounted flash sales' },
  discountedExperiencesTitle: { id: 'wXt00nLXzxVZ8ZdZdCDq', defaultMessage: 'Discounted pricing on local experiences', description: 'Landing page benefit title for discounted experiences' },
  discountedExperiencesDescription: { id: 'e7A4ChdeEO1xGyXMC6eK', defaultMessage: 'Dining, activities, attractions and more', description: 'Landing page benefit description for discounted experiences' },
  hotelInclusionsTitle: { id: 'TxyFx2UB71J-IJAWcDsu', defaultMessage: 'Bonus inclusions on select hotels', description: 'Landing page benefit title for hotel inclusions' },
  hotelInclusionsDescription: { id: '3vFMFibQen6xcT43rX0o', defaultMessage: 'Hotel credit, daily breakfast and more', description: 'Landing page benefit description for hotel inclusions' },
  exclusiveOffersTitle: { id: '51ONRITbRzXQmz4J6WKR', defaultMessage: 'Member-only hotel offers', description: 'Landing page benefit title for exclusive offers' },
  earlyAccessTitle: { id: 'oUdyy583-44ykIt9ZJg7', defaultMessage: 'Early access to our bestselling offers', description: 'Landing page benefit title for early access' },
  discountedToursTitle: { id: 'nQon7AmM1KrgnlH2meCA', defaultMessage: 'Discounted pricing on select Luxury Escapes tours', description: 'Landing page benefit title for discounted tours' },
  cruiseInclusionsTitle: { id: 'x7v8MyeoB1pMxiPofp8Q', defaultMessage: 'Bonus onboard credit on select cruises', description: 'Landing page benefit title for cruise inclusions' },
  prioritySupportTitle: { id: 'CnqtCp2UQeOoRWMhyE9c', defaultMessage: 'Priority access to 24/7 customer support', description: 'Landing page benefit title for priority support' },
  prioritySupportDescription: { id: 'HKGDni2leRl8w9KKb8Lz', defaultMessage: 'Call 1300 000 000', description: 'Landing page benefit description for priority support' },
  partnerOffersTitle: { id: '8ynZTEDHBpZ3ur7fd5tA', defaultMessage: 'Exclusive partner offers', description: 'Landing page benefit title for exclusive partner offers' },
  partnerOffersDescription: { id: 'nHZ-vWXfUdiPDKV9PZOB', defaultMessage: 'Special promotions from our trusted partners', description: 'Landing page benefit description for exclusive partner offers' },
  weeklyDiscountsTitle: { id: 'rybVdNk5kQ_lHWy52C7C', defaultMessage: 'Weekly member-only discounts', description: 'Landing page benefit title for weekly member-only discounts' },
} as const
